import { Card, CardContent, Typography, Grid } from "@mui/material";
import { DebtDetail, DebtType, PolicyOrAccount } from "../../../../interfaces/DTO/mislaka_xml_models";
import { formatIsoDate, formatCurrency } from "../../../../utils/namesFormater";
import { formatYesNo } from "../../../../utils/pensionEnumFormatter";
import { formatDebtType } from "../../../../utils/enumFormatter";


interface DebtDetailCardProps {
  debt: DebtDetail;
}

interface FieldDef<T> {
  field: keyof T;
  label: string;
  format?: (value: any) => string | number;
}

const debtFieldDefs: FieldDef<DebtDetail>[] = [
  { field: 'exists', label: 'חוב קיים', format: formatYesNo },
  { field: 'start_date', label: 'תאריך תחילת חוב', format: formatIsoDate },
  { field: 'corrected_start_date', label: 'תאריך מתוקן', format: formatIsoDate },
  { field: 'months_count', label: 'מספר חודשי חוב' },
  { field: 'debt_type', label: 'סוג חוב', format: formatDebtType },
  { field: 'total_debt', label: 'סה"כ חוב', format: formatCurrency },
  { field: 'non_allocated_funds', label: 'כספים לא משויכים', format: formatYesNo },
];


export const DebtDetailCard: React.FC<DebtDetailCardProps> = ({ debt }) => {
  return (
    <Card className="rounded-2xl shadow-md p-4">
      <CardContent>
        <Typography variant="h6" gutterBottom>
          פרטי חוב
        </Typography>
        <Grid container spacing={2}>
          {debtFieldDefs.map(({ field, label, format }) => {
            const value = debt[field];
            if (value == null || value === '') return null;
            const display = format ? format(value) : value;
            return (
              <Grid item xs={12} sm={6} key={field as string}>
                <strong>{label}:</strong> {display}
              </Grid>
            );
          })}
        </Grid>
      </CardContent>
    </Card>
  );
};


export const ProductDebtTab: React.FC<{ policies: PolicyOrAccount[] }> = ({ policies }) => {
  const allDebts = policies.flatMap(p => p.debt_details || []);
  if (allDebts.length === 0) return null;

  return (
    <div className="space-y-4">
      {allDebts.map((debt, idx) => (
        <DebtDetailCard key={idx} debt={debt} />
      ))}
    </div>
  );
};

